import type { ComplianceState } from './api'

/** Every standing a record's paperwork can have, in the order a sorted column lists them. */
export const COMPLIANCE_STATES: readonly ComplianceState[] = ['Active', 'Pending', 'Blocked']

/**
 * Where a standing sorts: compliant first, then paperwork incomplete, then blocked — the order
 * a dispatcher reads a list in when the column is sorted (TRKC-110).
 */
export function complianceRank(state: ComplianceState): number {
  return COMPLIANCE_STATES.indexOf(state)
}
